import { connect } from "react-redux";
import TicketBase from "../components/TicketBase";
import * as actionsTicket from "../../../_actions/ticket";
import * as actionsMisc from "../../../_actions/misc";
import * as actionsAuth from "../../../_actions/auth";

const mapStateToProps = ({ Ticket, Dimension, Misc }) => ({
    //Ticket
    ticketLoading: Ticket.fetching.loading,
    ticketFetchingError: Ticket.fetching.err,
    ticket: Ticket.data && Ticket.data.result,
    ticketUpdating: Ticket.updating.loading,
    ticketUpdatingError: Ticket.updating.err,
    returnLabelLoading: Ticket.returnLabelFetching.loading,
    returnLabelLoadingError: Ticket.returnLabelFetching.err,
    //Dimension
    languageListLoading: Dimension.Language.fetching.loading,
    languageList: Dimension.Language.languageList,
    countryListLoading: Dimension.Country.fetching.loading,
    countryList: Dimension.Country.countryList,
    // provinceListLoading: Dimension.Province.fetching.loading,
    // provinceList: Dimension.Province.provinceList,
    referencePlatformListLoading: Dimension.ReferencePlatform.fetching.loading,
    referencePlatformList: Dimension.ReferencePlatform.referencePlatformList,
    requestTypeListLoading: Dimension.RequestType.fetching.loading,
    requestTypeList: Dimension.RequestType.requestTypeList,
    returnReasonListLoading: Dimension.ReturnReason.fetching.loading,
    returnReasonList: Dimension.ReturnReason.returnReasonList,

    //Misc
    language: Misc.Settings.language,
    authToken: Misc.Auth.token,
    authTokenLoading: Misc.Auth.fetching.loading,
    authTokenFetchingError: Misc.Auth.fetching.err,
    ticketVerifyData: Ticket.verify,
    ticketVerifying: Ticket.verifying.loading,
    ticketVerifyingError: Ticket.verifying.err
});

const mapDispatchToProps = dispatch => ({
    getTicket: ticketId => {
        dispatch(actionsTicket.getTicket(ticketId));
    },
    resetTicket: () => {
        dispatch(actionsTicket.resetTicket());
    },
    setLanguage: language => {
        dispatch(actionsMisc.setLanguage(language));
    },
    resetLanguage: () => {
        dispatch(actionsMisc.resetLanguage());
    },
    setAuthToken: token => {
        dispatch(actionsAuth.setAuthToken(token));
    },
    verifyTicket: ticketId => {
        dispatch(actionsTicket.verifyTicket(ticketId));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(TicketBase);
